import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import moment from "moment";
import { DOMAIN } from "./domain-constant";
import { AppIcons } from "../constants/app-icons";
export default class FixedAssets extends ApiService {
  namespace = "fixed-asset";
  template = "defaultTemplate";
  fullWindow = false;
  DOMAIN = DOMAIN.FIXED_ASSET;
  icon = "House";
  action = "action";
  Width = 1200;
  data = [];
  favicon = "Home";
  name = "Invoices";
  singular = this.terminology.fixAsset.singular;
  plural = this.terminology.fixAsset.plural;
  vowel = this.terminology.fixAsset.vowel;
  gemItems = [
    {
      key: "listing",
      label: "View Fixed Assets",
      icon: PrimeIcons.LIST,
    },
    {
      key: "create",
      label: "Add a Fixed Asset",
      icon: PrimeIcons.PLUS,
    },
  ];
  columns = [
    {
      header: this.t("displayName"),
      icon: AppIcons.HOME,
      field: "number",
    },

    {
      header: this.t("date"),
      icon: AppIcons.CALENDAR,
      field: "date",
      template: (data) => {
        return moment.unix(data.date).format("MM/DD/YYYY").format("MM/DD/YYYY");
      },
    },

    {
      icon: AppIcons.DOCUMENT,
      field: "amount",
      width: "3",
    },
    {
      icon: AppIcons.MONEY,
      field: "received",
      width: "3",
    },
    {
      icon: AppIcons.USER_SILHOUETTE,
      field: "balance",
      width: "3",
    },
    {
      icon: AppIcons.DOCUMENT,
      field: "status",
      width: "3",
    },

    {
      icon: AppIcons.COMPUTER,
      field: "edit",
      width: "3",
    },
    {
      icon: AppIcons.COMPUTER,
      field: "edit",
      width: "3",
    },
  ];

  navItems = [
    {
      key: "listing",
      label: this.t("viewAllEntities", { entity: this.plural }),
      icon: AppIcons.BULLETS,
    },
    {
      key: "bookmark",
      label: this.t("viewMyBookmarks", { entity: this.singular }),
      icon: AppIcons.BOOKMARK,
    },
    {
      key: "inactive",
      label: this.t("viewInactiveEntity", { entity: this.plural }),
      services: 18,
      icon: AppIcons.DISABLE,
    },
  ];

  filterItems = [
    { name: "Type", key: "type", value: "2", realm: "2" },
    { name: "Category", key: "category", value: "3", realm: "1" },
    { name: "Folder", key: "folder", value: "4", realm: "0" },
  ];
  gemMenuItems = [
    {
      key: "create",
      label: "Adding an Fixed Asset",
      icon: AppIcons.LIST,
    },
  ];

  constructor() {
    super("assets");
  }
}
